export default __webpack_public_path__ + "static/media/YoutubeDemoPage18.e0538f11.png";